// extracted by mini-css-extract-plugin
export default {"standardTable":"index_standardTable__BpqLR","header":"index_header__M5kba","changelog":"index_changelog__Ga0NC","expandedRowContainer":"index_expandedRowContainer__s-XNU"};